import React from "react";
import * as CommandPrimitive from "cmdk";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { Organization } from "./types";

export const getOrganization = (): Organization | undefined => {
  const selected = localStorage.getItem("selected_organization");
  if (!selected) {
    return;
  }
  return JSON.parse(selected);
};

export const getMenuComponents = (shouldUseCmd: boolean) => {
  const Component = shouldUseCmd ? PopoverPrimitive : DropdownMenuPrimitive;
  const ComponentItem = shouldUseCmd
    ? CommandPrimitive.CommandItem
    : DropdownMenuPrimitive.Item;
  const ListComponent = shouldUseCmd
    ? CommandPrimitive.CommandList
    : React.Fragment;
  const GroupComponent = shouldUseCmd
    ? CommandPrimitive.CommandGroup
    : React.Fragment;
  const CommandComponent = shouldUseCmd
    ? CommandPrimitive.Command
    : React.Fragment;
  return {
    Component,
    ComponentItem,
    ListComponent,
    GroupComponent,
    CommandComponent,
  };
};

export const mockOrganizations = [
  {
    mapspeopleApiKey: "api-key-1",
    modificationTimestampNanos: "1680146400000000000",
    modificationUserId: "user-001",
    name: "Acme Corp",
    orgId: "org-001",
    orgType: "Enterprise",
    pairingCode: "pairing-code-001",
    paymentStartYear: 2023,
    readerApiCode: "reader-api-123",
    status: "ACTIVE",
    validUntilTimestampNanos: "1711682400000000000",
  },
  {
    mapspeopleApiKey: "api-key-2",
    modificationTimestampNanos: "1680146400000000000",
    modificationUserId: "user-002",
    name: "Beta LLC",
    orgId: "org-002",
    orgType: "Nonprofit",
    pairingCode: "pairing-code-002",
    paymentStartYear: 2024,
    readerApiCode: "reader-api-456",
    status: "ACTIVE",
    validUntilTimestampNanos: "1743224400000000000",
  },
  {
    mapspeopleApiKey: "api-key-3",
    modificationTimestampNanos: "1680146400000000000",
    modificationUserId: "user-003",
    name: "Gamma Enterprises",
    orgId: "org-003",
    orgType: "Startup",
    pairingCode: "pairing-code-003",
    paymentStartYear: 2022,
    readerApiCode: "reader-api-789",
    status: "ACTIVE",
    validUntilTimestampNanos: "1774766400000000000",
  },
  {
    mapspeopleApiKey: "api-key-4",
    modificationTimestampNanos: "1680146400000000000",
    modificationUserId: "user-004",
    name: "Acme Corp 2",
    orgId: "org-004",
    orgType: "Enterprise",
    pairingCode: "pairing-code-002",
    paymentStartYear: 2023,
    readerApiCode: "reader-api-123",
    status: "ACTIVE",
    validUntilTimestampNanos: "1711682400000000000",
  },
  {
    mapspeopleApiKey: "api-key-5",
    modificationTimestampNanos: "1680146400000000000",
    modificationUserId: "user-005",
    name: "Beta LLC 2",
    orgId: "org-005",
    orgType: "Nonprofit",
    pairingCode: "pairing-code-005",
    paymentStartYear: 2024,
    readerApiCode: "reader-api-456",
    status: "ACTIVE",
    validUntilTimestampNanos: "1743224400000000000",
  },
  {
    mapspeopleApiKey: "api-key-6",
    modificationTimestampNanos: "1680146400000000000",
    modificationUserId: "user-006",
    name: "Gamma Enterprises 2",
    orgId: "org-006",
    orgType: "Startup",
    pairingCode: "pairing-code-006",
    paymentStartYear: 2022,
    readerApiCode: "reader-api-789",
    status: "ACTIVE",
    validUntilTimestampNanos: "1774766400000000000",
  },
];
